module.exports = __webpack_public_path__ + "4d8f24e224d07c5643424180cc470224.svg";